(() => {
  document.addEventListener('DOMContentLoaded', () => { 
    const tables = document.querySelectorAll('.variantListTable');
    
    if ( !tables ) return;

    tables.forEach(table => {
      const list_items = Array.from(table.querySelectorAll('[data-sort]'));
  
      list_items.sort((a, b) => {
        const valueA = parseInt(a.dataset.sort);
        const valueB = parseInt(b.dataset.sort);
  
        if (isNaN(valueA) && isNaN(valueB)) {
          return 0; // Both are NaN, leave them in their current order.
        }
        if (isNaN(valueA)) {
          return 1; // Put NaN at the end.
        }
        if (isNaN(valueB)) {
          return -1; // Put NaN at the end.
        }
        return valueA - valueB;
      });
      
      list_items.forEach(item => table.querySelector('tbody').appendChild(item));
    });
  });
})();

